export interface IEnvConfig {
  NODE_ENV: string;
  SENTRY_DSN: string;
  YANDEX_METRIKA_ID: string;
  SMARTCAPTCHA_CLIENT_KEY: string;
}

export const envConfig = (
  import.meta.env.MODE === 'development'
    ? {
        NODE_ENV: import.meta.env.MODE,
        SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN as string,
        YANDEX_METRIKA_ID: import.meta.env.VITE_YANDEX_METRIKA_ID as string,
        SMARTCAPTCHA_CLIENT_KEY: import.meta.env.VITE_SMARTCAPTCHA_CLIENT_KEY as string,
      }
    : (window as any).env
) as IEnvConfig;

export const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
export const PHONE_PATTERN = /^\+\d \(\d{3}\) \d{3}-\d{2}-\d{2}$/;
export const PHONE_PATTERN_WITH_CODE = /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/;
export const PRICE_PATTERN = /\B(?=(\d{3})+(?!\d))/g;
export const INTEGER_PATTERN = /^[0-9]+$/;
export const ESCAPE_REGEX_PATTERN = /[.*+?^${}()|[\]\\]/g;
export const NUMBER_PATTERN = /^[0-9\b]+$/;
export const URL_PATTERN = /^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?(\?[^\s#]*)?(#[^\s]*)?$/;
export const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const PHONE_MASK = '+7 (999) 999-99-99';
export const PHONE_MASK_BY = '+375 (99) 999-99-99';
export const PHONE_PATTERN_BY = /^\+375 \(\d{2}\) \d{3}-\d{2}-\d{2}$/;

export const DEFAULT_DEBOUNCE_DELAY = 800;
export const COUNT_CHANGE_DELAY = 200;

export const AUTH_REDIRECT_TIMEOUT_MS = 2000;

export const ACTIVATION_STEP_ONE = 1;
export const ACTIVATION_STEP_TWO = 2;
export const ACTIVATION_STEP_THREE = 3;

export const PROPERTY_CASCADER_CHARACTER_LIMIT_MIN = 1;
export const PROPERTY_CASCADER_ITEM_PROPERTY_OFFSET = 50;

export const LEGAL_INN_LENGTH_10 = 10;
export const LEGAL_INN_LENGTH_12 = 12;
export const LEGAL_KPP_LENGTH = 9;

export const LIST_LIMIT_20 = 20;
export const LIST_LIMIT_10 = 10;
export const LIST_LIMIT_5 = 5;
export const LIST_LIMIT_0 = 0;
export const LIST_LIMIT_FOR_NEEDS = 100;

export const ITEMS_FOR_VIEW_LIMIT_11 = 11;
export const ITEMS_FOR_VIEW_LIMIT_10 = 10;
export const ITEMS_FOR_VIEW_LIMIT_8 = 8;
export const ITEMS_FOR_VIEW_LIMIT_4 = 4;

export const DEFAULT_EMPTY_VALUE = -1;
export const DEFAULT_VALUE_1 = 1;
export const DEFAULT_VALUE_0 = 0;

export const SELECT_LIST_HEIGHT_210 = 210;
export const SELECT_LIST_HEIGHT_320 = 320;
export const SELECT_LIST_HEIGHT_334 = 334;

export const PROGRESS_STEPS_DEFAULT_VALUE = 0;
export const PROGRESS_STEP_WIDTH_PX = 10;

export const PERCENT_50 = 50;
export const PERCENT_100 = 100;

export const FILES_SIZE_LIMIT_MB = 5;
export const BYTE_TO_KILOBYTE = 1000;
export const BYTE_TO_MEGABYTE = 1000000;

export const VISIBLE_IMAGES_LIMIT_3 = 3;
export const VISIBLE_IMAGES_LIMIT_4 = 4;

export const PRICE_LIMIT = 99999999.99;

export const PREVIOUS_PATH_KEY = 'previousPath';
export const JIVO_SRC = '//code.jivo.ru/widget/WgVeogLWuw';
export const ALL_DOCS_EXTS = 'image/jpeg, image/png';
export const RANGE_VALUE_MIN = '0.1';
export const DEFAULT_COUNTER_MAX_VALUE = 10000;
export const STATISTICS_OVERFLOW_COUNT = 999;
export const DEFAULT_DELIVERY_IN_DAYS = 180;
export const CHARACTER_LIMIT_MIN = 3;
export const SUPPLIES_COUNT_MIN = 1;
export const DEFAULT_GOODS_COUNT = 1;
export const UPLOADING_DOCS_COUNT = 1;
export const DEFAULT_PAGINATION_PAGE = 1;
export const CHIP_LIST_LIMIT = 1;
export const DEFAULT_BASIC_DISCOUNT = 0;
export const DEFAULT_LIST_OFFSET = 0;

export const RU_ALPHABET = [
  'А',
  'Б',
  'В',
  'Г',
  'Д',
  'Е',
  'Ё',
  'Ж',
  'З',
  'И',
  'Й',
  'К',
  'Л',
  'М',
  'Н',
  'О',
  'П',
  'Р',
  'С',
  'Т',
  'У',
  'Ф',
  'Х',
  'Ц',
  'Ч',
  'Ш',
  'Щ',
  'Ъ',
  'Ы',
  'Ь',
  'Э',
  'Ю',
  'Я',
];
export const EN_ALPHABET = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];
